/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Emailplaceholder2Inputs */

const zh_organizationsettings_emailplaceholder2 = /** @type {(inputs: Organizationsettings_Emailplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jane@example.com`)
};

const en_organizationsettings_emailplaceholder2 = /** @type {(inputs: Organizationsettings_Emailplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jane@example.com`)
};

const es_organizationsettings_emailplaceholder2 = /** @type {(inputs: Organizationsettings_Emailplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jane@example.com`)
};

/**
* | output |
* | --- |
* | "jane@example.com" |
*
* @param {Organizationsettings_Emailplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_emailplaceholder2 = /** @type {((inputs?: Organizationsettings_Emailplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Emailplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_emailplaceholder2(inputs)
	if (locale === "en") return en_organizationsettings_emailplaceholder2(inputs)
	return es_organizationsettings_emailplaceholder2(inputs)
});
export { organizationsettings_emailplaceholder2 as "organizationSettings_emailPlaceholder" }